/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMarsStroke = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v7h-2V5.413l-3.086 3.086 1.793 1.794-1.414 1.414-1.794-1.793-.893.894a7 7 0 1 1-1.415-1.415l.894-.893-1.792-1.793 1.414-1.414L15.5 7.085 18.584 4H15V2zM9 10a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMarsStroke as MarsStroke };
